import $ from 'jquery';

$(document).ready(() => {
	$('.hero').slick({
		autoplay: true,
		autoplaySpeed: 3000,
		fade: true,
		pauseOnFocus: false,
		pauseOnHover: false,
	});
});



// WEBPACK FOOTER //
// ./src/js/components/hero.js